import {
  reqUploadAvFileToFtp
} from '@/api/jt1078dataserv'

export default {
  state: {
    state_Jt1078Data_ReqUploadAvFileToFtpResult: null
  },
  mutations: {
    SET_JT1078DATA_REQUPLOADAVFILETOFTP_RESULT: (state, rst) => {
      state.state_Jt1078Data_ReqUploadAvFileToFtpResult = rst
    }
  },
  actions: {
    Jt1078DataServ_ReqUploadAvFileToFtp ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        reqUploadAvFileToFtp(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT1078DATA_REQUPLOADAVFILETOFTP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT1078DATA_REQUPLOADAVFILETOFTP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Jt1078Data_ReqUploadAvFileToFtpResult: state => {
      return state.state_Jt1078Data_ReqUploadAvFileToFtpResult
    }
  }
}
